import { useAvatarResolver } from "../components/avatar-provider.js";
import { loadRoundStoryCard } from "../pages/feed/use-round-story.js";
import { ShareCardButton } from "./share-card-button.js";
import { posterShareCard } from "./round-poster-share-model.js";

export function usePosterShareCard() {
  const avatar = useAvatarResolver();
  return async (roundId: string) => {
    const card = await loadRoundStoryCard(roundId);
    const avatars = Object.fromEntries(
      card.sides.flatMap((side) =>
        side.participantIds.map((participantId) => [
          participantId,
          avatar({ participantId }),
        ]),
      ),
    );
    return posterShareCard(card, avatars);
  };
}
export function RoundPosterShare({ roundId }: { roundId: string }) {
  const card = usePosterShareCard();
  return (
    <ShareCardButton
      label="Share result"
      variant="link"
      size="sm"
      card={() => card(roundId)}
    />
  );
}
